@if (safeRichContent()) {
  <iframe #richContentIframe id="rich-content-iframe" title="Content" [style.height]="iframeHeight() + 'px'" [srcdoc]="safeRichContent()">
  </iframe>
}
@if (safeRichContent() && showExpandControls()) {
  <div class="button-row">
    @if (!iframeContentHeight() || iframeHeight() < iframeContentHeight()) {
      <button mat-button color="primary" (click)="expandFrame()">
        <mat-icon class="with-text">unfold_more</mat-icon>{{ 'Expand' | translate:locale.language }}
      </button>
    }
    @if (iframeHeight() > maxAutoIframeHeight()) {
      <button mat-button color="primary" (click)="resetFrame()">
        <mat-icon class="with-text">unfold_less</mat-icon>{{ 'Reset' | translate:locale.language }}
      </button>
    }
  </div>
}
